import { isAuthenticated } from '../utils/authHelper';
import React from 'react';
import { MuiThemeProvider } from '@material-ui/core/styles'
import Snackbar from '@material-ui/core/Snackbar';
import Delete from '@material-ui/icons/Delete'
import Info from '@material-ui/icons/Visibility'
import ICircledIcon from '@material-ui/icons/Info'
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import Edit from '@material-ui/icons/Edit';
import Deactivate from '@material-ui/icons/PowerSettingsNew'
import Activate from '@material-ui/icons/SettingsBackupRestore'
import Tooltip from '@material-ui/core/Tooltip';
import Table from './VendorListtable'
import Header from './Header'
import userdata from '../config/jwt_token'
import { browserHistory } from 'react-router'
import { getApprovedVendors, sendActivateRequest, sendDeactivateRequest, sendDeleteRequest, bulkUpdateVendors, checkVendorActivePayments } from '../utils/VendorApiUtils'
import { TextField } from '@material-ui/core';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import InputLabel from '@material-ui/core/InputLabel'
import FormControl from '@material-ui/core/FormControl'

const SAMPLE_DEFAULTOR_UPDATE_URL = 'https://docs.google.com/spreadsheets/d/1SilngEENh7mBwYhQan-igfNeAQ6KC2R-D5ytxiWePK4/edit#gid=191887113';
const SAMPLE_GSTN_STATUS_UPDATE_URL = 'https://docs.google.com/spreadsheets/d/1SilngEENh7mBwYhQan-igfNeAQ6KC2R-D5ytxiWePK4/edit#gid=823075677'
const SAMPLE_PAN_STATUS_UPDATE_URL = 'https://docs.google.com/spreadsheets/d/1SilngEENh7mBwYhQan-igfNeAQ6KC2R-D5ytxiWePK4/edit#gid=1323790376'
class PendingApproval extends React.Component {
  constructor(props) {
    super(props)
    if (!isAuthenticated()) {
      browserHistory.push('/')
    }
    this.state = {
      state: 'pending',
      value: 0,
      data: undefined,
      dialogBox: false,
      index: '',
      status: '',
      snackOpen: false,
      snackText: '',
      nationalVendorDialogBox: false,
      nationalVendorDialogBoxText: '',
      vendorActivePayments: [],
      vendorActivePaymentsDialogBox: {
        open: false,
        message: 'These vendors have active payments, please deactivate their payments first before editing',
      },
      vendorUpdateTypelist: [
        { name: 'Vendor GSTIN status', value: 'gstn_status' },
        { name: 'Vendor defaulter Amount', value: 'defaulter_amount' },
        { name: 'Vendor PAN status', value: 'pan_status' },
        // { name: 'Vendor LDC', value: 'vendor_ldc' }
      ],
      vendorUpdateType: ''
    }

  }
  componentDidMount() {
    getApprovedVendors().then((response) => {
      if (response) {
        if (response.status === 'success') {
          let approved = response.data.map((data, index) => {
            if(data.vendors && data.vendors.vendor_agreement === 1) {
              data.vendors.agreement_expiry_date = data.vendors.agreement_expiry_date ? new Date(data.vendors.agreement_expiry_date) : null
              data.vendor_agreement = String(data.vendors.vendor_agreement)
              data.vendor_agreement_file_name = data.vendors.vendor_agreement_file_name != 'null' ? data.vendors.vendor_agreement_file_name : ''
            }
            if(data.vendors && data.vendors.vendor_ldc_agreement === 1) {
              data.vendors.ldc_agreement_start_date = data.vendors.ldc_agreement_start_date ? new Date(data.vendors.ldc_agreement_start_date) : null
              data.vendors.ldc_agreement_end_date = data.vendors.ldc_agreement_end_date ? new Date(data.vendors.ldc_agreement_end_date) : null
              data.vendor_ldc_agreement = String(data.vendors.vendor_ldc_agreement)
              data.vendor_ldc_agreement_file_name = data.vendors.vendor_ldc_agreement_file_name != 'null' ? data.vendors.vendor_ldc_agreement_file_name : ''
            }
            let vendorData = (userdata.role.indexOf('Central Finance') !== -1 || userdata.role === 'Vendor Approver L2')? {
              ...data, ...data.vendors, ...data.acc_details[0], ...data.addresses[0],
              preview: <div>
                <Info style={{ cursor: 'pointer' }} onClick={this.handleApproval.bind(this, 'info', data)} /></div>
            } : {
                ...data, ...data.vendors, ...data.acc_details[0], ...data.addresses[0],
                preview: data.vendors.vendor_deactivate == 1 ? (
                  <div>
                    <Info style={{ cursor: 'pointer' }} onClick={this.handleClick.bind(this, 'info', index)} />
                    <Activate style={{ marginLeft: '20px', cursor: 'pointer' }} onClick={this.handleActivateVendor.bind(this, index, 'activate')} />
                  </div>
                ) : (
                  <div>
                    <Info style={{ cursor: 'pointer' }} onClick={this.handleClick.bind(this, 'info', index)} />
                    <Edit style={{ marginLeft: '20px', cursor: 'pointer' }} onClick={this.handleClick.bind(this, 'edit', index)} />
                    <Delete style={{ marginLeft: '20px', cursor: 'pointer' }} onClick={this.handleDelete.bind(this, index, 'delete')} />
                    <Deactivate style={{ marginLeft: '20px', cursor: 'pointer' }} onClick={this.handleDelete.bind(this, index, 'deactivate')} />
                  </div>
                )
                  
              }
            delete vendorData.vendors
            delete vendorData.acc_details
            delete vendorData.addresses
            return vendorData
          })
          this.setState({ data: approved, state: 'approved' })
        }

        else if (response.status === 'failure') {
          this.setState({ snackOpen: true, snackText: response.message })
        }
      }
    })
  }

  handleActivateVendor(index, value) {
    const selectedCity = localStorage.getItem('selected_city')
    if(selectedCity !== this.state.data[index].city_name)
      this.setState({
       nationalVendorDialogBox: true, nationalVendorDialogBoxText: `This vendor can only be edited/deleted by the city-finance team of ${this.state.data[index].city_name}. Please contact them.`
      })
    else {
      this.setState({
        dialogBox: true,
        index,
        status: value,
        title: 'Are you sure you want to activated this vendor?',
      })
    }
  }

  handleDelete(index, value) {
    const selectedCity = localStorage.getItem('selected_city')
    if(selectedCity !== this.state.data[index].city_name)
      this.setState({
       nationalVendorDialogBox: true, nationalVendorDialogBoxText: `This vendor can only be edited/deleted by the city-finance team of ${this.state.data[index].city_name}. Please contact them.`
      })
    else {
      if(value == 'delete') {
        this.setState({
          dialogBox: true,
          index,
          status: value,
          title: 'Are you sure you want to delete this vendor?',
        })
      } 
      else if(value == 'deactivate') {
        this.setState({
          dialogBox: true,
          index,
          status: value,
          title: 'Are you sure you want to deactivate this vendor?',
        })
      }
    }
      
  }
  handleCloseNationalVendorDialogBox(){
    this.setState({nationalVendorDialogBox: false, nationalVendorDialogBoxText:''})
  }
  handleApproval(value, data, event) {
    let vendorData = { ...data, ...data.vendors, ...data.acc_details[0], ...data.addresses[0] }
    delete vendorData.vendors
    delete vendorData.acc_details
    delete vendorData.addresses
    browserHistory.push({
      pathname: '/vendor/approved/info',
      state: { ...vendorData, state: value }
    })
  }

  async fetchVendorActivePayments (vendor_buffer_id) {
    const response = await checkVendorActivePayments(vendor_buffer_id);
    return response;
  }

  async handleYes() {
    if(this.state.status === 'delete') {
      const isActivePayments = await this.fetchVendorActivePayments( this.state.data[this.state.index].vendor_buffer_id);
      if (isActivePayments && isActivePayments.flag && isActivePayments.data.length > 0) {
        this.setState({
          vendorActivePaymentsDialogBox: {
            ...this.state.vendorActivePaymentsDialogBox,
            open: true,
            message: 'This vendor has active payments, cannot edit the vendor.'
          },
          vendorActivePayments: [],
          dialogBox: false
        })
      } else {
        sendDeleteRequest(JSON.stringify({
          'vendor_buffer_id': this.state.data[this.state.index].vendor_buffer_id
        }))
        .then((response) => {
          if (response) {
            if (response.status === 'success') {
              this.setState({ snackOpen: true, snackText: 'Sent for Approval', dialogBox: false })
            }

            else if (response.status === 'failure') {
              this.setState({ snackOpen: true, snackText: response.message })
            }
          }
        })
      }
    } else if (this.state.status === 'deactivate') {
        const isActivePayments = await this.fetchVendorActivePayments( this.state.data[this.state.index].vendor_buffer_id);
        if (isActivePayments && isActivePayments.flag && isActivePayments.data.length > 0) {
          this.setState({
            vendorActivePaymentsDialogBox: {
              ...this.state.vendorActivePaymentsDialogBox,
              open: true,
              message: 'This vendor has active payments, cannot edit the vendor.'
            },
            vendorActivePayments: [],
            dialogBox: false
          })
        } else {
        sendDeactivateRequest(JSON.stringify({
          'vendor_buffer_id': this.state.data[this.state.index].vendor_buffer_id
        }))
        .then((response) => {
          if (response) {
            if (response.status === 'success') {
              this.setState({ snackOpen: true, snackText: 'Sent for Approval', dialogBox: false })
            }
    
            else if (response.status === 'failure') {
              this.setState({ snackOpen: true, snackText: response.message })
            }
          }
        })
      }
    } else if (this.state.status === 'activate') {
      sendActivateRequest(JSON.stringify({
        'vendor_buffer_id': this.state.data[this.state.index].vendor_buffer_id
      }))
      .then((response) => {
        if (response) {
          if (response.status === 'success') {
            this.setState({ snackOpen: true, snackText: 'Sent for Approval', dialogBox: false })
          }
  
          else if (response.status === 'failure') {
            this.setState({ snackOpen: true, snackText: response.message })
          }
        }
      })
    }
  }
  handleCloseSnack() {
    this.setState({ snackOpen: false, snackText: '' })
  }
  handleNo() {
    this.setState({ dialogBox: false })
  }
  handleClick(value, index, event) {
    let data = this.state.data[index]
    if (value === 'edit') {
      let vendorBasicDetais = {
        name: data.name,
        contact_person_name: data.contact_person_name,
        address: data.address,
        city_name: data.city_name,
        city_id: data.city_id,
        state_name: data.state_name,
        contact_number: data.contact_number,
        alternate_contact_number: data.alternate_contact_number,
        email_id: data.email_id,
        transaction_id: data.transaction_id,
        transaction_pointer: data.transaction_pointer,
        transaction_state: data.transaction_state,
        vendor_buffer_id: data.vendor_buffer_id,
        status: data.status,
        national: data.national,
        transaction_type: data.transaction_type

      }
      let vendorFinancialDetails = {
        payment_mode: data.payment_mode,
        beneficiary_name: data.beneficiary_name,
        bank_acc_number: data.bank_acc_number,
        ifsc_code: data.ifsc_code,
        bank_name: data.bank_name,
        cancel_cheque_upload_file: data.cancel_cheque_upload_file,
        cancel_cheque_upload_file_name: data.cancel_cheque_upload_file_name,
        tds_liability: data.tds_liability,
        tds_liability_remarks: data.tds_liability_remarks,
        confirm_bank_acc_number: data.bank_acc_number,
        pancard_number: data.pancard_number,
        pancard_file: data.pancard_file,
        pancard_file_name: data.pancard_file_name,
        msme_vendor: data.msme_vendor,
        msme_certificate_file: data.msme_certificate,
        msme_certificate_file_name: data.msme_certificate_file_name || data.msme_certificate,
        pancard_status: data.pancard_status,
        aadhar_number: data.aadhar_number,
        aadhar_file: data.aadhar_file,
        aadhar_file_name: data.aadhar_file_name,
        trade_licence_file: data.trade_licence_file,
        trade_licence_file_name: data.trade_licence_file_name,
        company_category: data.company_category,
        contractual_terms: data.contractual_terms,
        central_finance_remarks: data.central_finance_remarks,
        city_finance_remarks: data.city_finance_remarks,
        vendor_agreement: data.vendor_agreement,
        agreement_expiry_date: data.agreement_expiry_date,
        vendor_agreement_file_name: data.vendor_agreement_file_name,
        defaultor_amount: data.defaultor_amount,
        vendor_ldc_agreement: data.vendor_ldc_agreement,
        ldc_agreement_start_date: data.ldc_agreement_start_date,
        ldc_agreement_end_date: data.ldc_agreement_end_date,
        ldc_tds_rate_data: data.ldc_tds_rate_data,
        vendor_ldc_agreement_file_name: data.vendor_ldc_agreement_file_name,
        ldc_amount_limit: data.ldc_amount_limit,
      }
      let vendorGstDetails = {
        gstn: data.gstn,
        gstn_verified: data.gstn_verified,
        gstn_verification_remarks: data.gstn_verification_remarks,
        gstn_status: data.gstn_status,
        legal_name: data.legal_name,
        entity_type: data.entity_type,
        registration_type: data.registration_type,
        department_code: data.department_code,
        nature_of_business: data.nature_of_business,
        registration_date: data.registration_date
      }
      browserHistory.push({
        pathname: '/vendor/approved/edit',
        state: { vendorBasicDetais, vendorGstDetails, vendorFinancialDetails, state: value }
      })
    }
    if (value === 'info') {
      browserHistory.push({
        pathname: '/vendor/approved/info',
        state: { ...data, state: value }
      })
    }
  }

  handleFileChange = (event) => {
    let file = event.target.files[0];
    if(file.type === "text/csv" || file.type === "application/octet-stream" || file.type === "application/vnd.ms-excel"){
      this.setState({ selectedFile: file, selectedFileName: file.name })
      return
    }
    else{
        this.setState({ snackOpen: true, snackText: 'Only Csv files are allowed.' })
        return
    }
  };

  handleUploadClose = () => {
    this.setState({ 
      uploadDialogOpen: false,
      selectedFileName: '',
      selectedFile: '',
      fileError: false,
      fileErrorText: '',
      fileUploading: false
    })
  }

  uploadStatus = async () => {
    this.setState({ fileUploading: true })
    // let selected_city = localStorage.getItem('selected_city');
    // if((!selected_city) && userdata.city.length > 0) {
    //   selected_city = userdata.city[0].city_name;
    //   localStorage.setItem('selected_city', selected_city);
    // }
    if(this.state.selectedFile){
      let data = new FormData()
      data.append('upload', this.state.selectedFile)
      data.append('type', this.state.vendorUpdateType)
      
      bulkUpdateVendors(data)
      .then((response) => {
        if(response.status){
          this.setState({ 
            selectedFileName: '', 
            selectedFile: '',
            fileError: false, 
            fileErrorText: '',
            uploadDialogOpen: false,
            snackOpen: true, 
            snackText: response.message || "Defaultor Vendors updated successfully",
            vendorActivePayments: response.activePaymentVendors
          })
          setTimeout(() => {
            if (response.activePaymentVendors.length > 0) {
              this.setState({
                vendorActivePaymentsDialogBox: {
                  ...this.state.vendorActivePaymentsDialogBox,
                  open: true,
                }
                })
            } else {
              window.location.reload();
            }
          }, 500)
        }
        else{
          this.setState({ 
            fileError: true, 
            fileErrorText: 'Error in uploading file' 
          })
        }
      })
      .catch((error) => {
        this.setState({ 
          fileError: true, 
          fileErrorText: 'Error in uploading file' 
        })
      });      
    }
    else{
      this.setState({ fileError: true, fileErrorText: 'Please select a file' })
    }
    this.setState({ fileUploading: false })
  }

  downloadGSTSheet = () => {
    if (this.state.data && this.state.data.length > 0) {
      // Create CSV header
      let csvContent = "Vendor Name,Vendor City,Vendor State,GST Number,Pan Number,Vendor Address, Onboarded Date\n";

      // Add each vendor's data to the CSV
      this.state.data.forEach(item => {
        const row = [
          item.name || '',
          item.city_name || '',
          item.state_name || '',
          item.gstn || '',
          item.pancard_number || '',
          item.address || '',
          item.created_at || ''
        ].map(value => `"${value.replace(/"/g, '""')}"`).join(',');

        csvContent += row + "\n";
      });

      // Create a Blob from the CSV content
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", "vendor_gst_details.csv");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      this.setState({ snackOpen: true, snackText: 'No data to export' });
    }
  }

  handleActivePaymentsDialogClose = () => {
    this.setState({ vendorActivePaymentsDialogBox: {
      ...this.state.vendorActivePaymentsDialogBox,
      open: false
    } })
  }

  handleVendorUpdateTypeChange = (event) => {
    this.setState({
      vendorUpdateType: event.target.value
    })
  }

  getVendorUploadTooltipText = () => {
    switch (this.state.vendorUpdateType) {
      case 'gstn_status':
        return 'Upload csv for updating GSTN status'
      case 'defaulter_amount':
        return 'Upload CSV for updating defaultor vendors'
      case 'pan_status':
        return 'Upload CSV for updating PAN status'
      // case 'vendor_ldc':
      //   return 'Upload CSV for updating LDC agreement'
      default:
        return 'Select type to upload CSV'
    }
  }

  getTemplateURL = () => {
    switch (this.state.vendorUpdateType) {
      case 'gstn_status':
        return SAMPLE_GSTN_STATUS_UPDATE_URL
      case 'defaulter_amount':
        return SAMPLE_DEFAULTOR_UPDATE_URL
      case 'pan_status':
        return SAMPLE_PAN_STATUS_UPDATE_URL
      default:
        return 'https://docs.google.com/spreadsheets'
    }
  }

  render() {
    return (
      <MuiThemeProvider>
        <Header />
        <div className="zaps-page-wrap">
          <div className="zaps-page-header">
            <div>
              <h2 className="zaps-page-title">Verified Vendors</h2>
              <p className="zaps-page-subtitle">Manage approved and active vendor records</p>
            </div>
            <div style={{ display: 'flex', gap: 10 }}>
              {this.state.data !== undefined && (
                <Button color="primary" autoFocus variant="outlined" onClick={this.downloadGSTSheet}>
                  Download GST Details
                </Button>
              )}
              {(userdata.role.indexOf('Central Finance') === -1 && userdata.role !== 'Vendor Approver L2') && this.state.data && (
                <Button color="primary" autoFocus variant="contained" onClick={() => this.setState({ uploadDialogOpen: true })}>
                  Update Vendor
                </Button>
              )}
            </div>
          </div>

          {this.state.data !== undefined && <Table data={this.state.data} status='approved' />}

        <Dialog
          open={this.state.dialogBox}
          onClose={this.handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent>
            <DialogTitle id="alert-dialog-title" style={{ padding: '0 0 20px 0' }}>
              {this.state.title ? this.state.title : "Are you sure you want to place a deletion  request?"}
            </DialogTitle>
            <DialogContentText id="alert-dialog-description">
              It will be confirmed after the approval
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleNo.bind(this)} color="primary">
              No
            </Button>
            <Button onClick={this.handleYes.bind(this)} color="primary" autoFocus>
              Yes
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={this.state.nationalVendorDialogBox}
          onClose={this.handleCloseNationalVendorDialogBox.bind(this)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {this.state.nationalVendorDialogBoxText}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleCloseNationalVendorDialogBox.bind(this)} color="primary" autoFocus>
              OK
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={this.state.uploadDialogOpen}
          onClose={this.handleUploadClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent>
          <FormControl style={{ marginTop: '10px', marginBottom: '20px' }}>
              <InputLabel htmlFor="msme-vendor">Vendor Update Type*</InputLabel>
              <Select
                value={this.state.vendorUpdateType}
                onChange={this.handleVendorUpdateTypeChange}
                inputProps={{
                  name: 'Vendor Update Type',
                  id: 'vendorUpdateType',
                }}
                style={{ width: '250px', textAlign: 'left' }}
                placeholder='Select type'
              >
                {
                  this.state.vendorUpdateTypelist.map(type => {
                    return <MenuItem value={type.value}>{type.name}</MenuItem>
                  })
                }
              </Select>
              </FormControl>
            <div 
              style={{ 
                textAlign: 'center',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center', 
              }}
            >
              <TextField
                label=" Upload CSV"
                value={this.state.selectedFileName}
                disabled={true}
                margin='normal'
                InputLabelProps = {{
                    shrink: true
                }}
                style={{ width: '250px' }}
                error={this.state.fileError}
                helperText={this.state.fileErrorText}
              />
              <label for={'file-upload'} class='custom-file-upload' style={{ border: '1px solid #ccc', display: 'inline-block', padding: '9px 12px', cursor: 'pointer', height: '16px', marginLeft: '5px', marginTop: '20px', color:'white', backgroundColor:'rgb(0, 188, 212)'}}>
                Browse
              </label>
              <input id={'file-upload'} type="file" onClick={(event) => event.target.value = null} onChange={this.handleFileChange.bind(this)} style={{ display: "none" }} accept="text/csv, application/octet-stream, application/vnd.ms-excel" disabled={this.state.vendorUpdateType === ''}/>
              <Tooltip title={this.getVendorUploadTooltipText()} placement="right">
                <ICircledIcon style={{ cursor: 'pointer', marginLeft: '10px', marginTop: '20px' }} onClick={() => {}} />
              </Tooltip>
            </div>
          </DialogContent>
          <DialogActions style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'end' }}>
            <Button variant="contained" href={this.getTemplateURL()} size="small" target="_blank" color="primary" disabled={this.state.vendorUpdateType === ''}>
              Download Template
            </Button>
            <div>
              <Button 
                onClick={this.handleUploadClose} 
                color="secondary" 
                variant="contained"
                style={{ marginRight: '10px' }}
                disabled={this.state.fileUploading}
              >
                Cancel
              </Button>
              <Button 
                onClick={this.uploadStatus} 
                color="primary" 
                autoFocus 
                variant="contained"
                disabled={this.state.fileUploading || this.state.vendorUpdateType === ''}
              >
                Upload
              </Button>
            </div>
          </DialogActions>
        </Dialog>
        <Dialog
          open={this.state.vendorActivePaymentsDialogBox.open}
          onClose={() => this.handleActivePaymentsDialogClose()}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent>
            <div style={{ textAlign: 'center', border: '1px dashed #FF0000' }}>
              {this.state.vendorActivePayments.map((vendor, index) => {
                return (
                 <List>
                  <ListItem key={index}>
                    <ListItemText primary={vendor.vendor_name} />
                    <ListItemText primary=":" />
                    <ListItemText style={{ minWidth: '240px', wordWrap: 'break-word' }} primary={vendor.vendor_gstn}/>
                  </ListItem>
                 </List> 
                    )})}
            <p>{this.state.vendorActivePaymentsDialogBox.message}</p>
            </div>
          </DialogContent>
        </Dialog>
        <Snackbar
          open={this.state.snackOpen}
          autoHideDuration={1000}
          onClose={this.handleCloseSnack.bind(this)}
          message={this.state.snackText}
        />
        </div>{/* end zaps-page-wrap */}
      </MuiThemeProvider>
    )
  }
}
export default PendingApproval



// WEBPACK FOOTER //
// ./src/components/ApprovedVendors.js